module.exports = __webpack_public_path__ + "img/bg_pc.754c3019.jpg";